export const EXPERIMENTS_SCOPE = 'specs.groups';
export const GROUP_LIST = 'group_list';
// https://pbo.wixpress.com/rpc-console-poc/wix-apps-webapp/app-jvm-137.42.wixprod.net/tpaDistributionService/getPublicApp?WyIzODM2YWUxOS04MDA0LTQyMmMtOTBhNC1hZWJlNzBhYWE0MjQiXQ==.e30=
export const GROUP_PAGE_NAME = 'Group Page';
